export default {
  'importMapping.column.issueVoidIndicator': 'Issue/Void Indicator',

  'importMapping.header.commaSeparatedImportFormat': 'Comma-Separated Import Format',
  'importMapping.header.fixedRecordImportFormat': 'Fixed-Record Import Format',

  'importMapping.message.noInformation': 'No information to display',
  'importMapping.message.savedSuccessfully': 'Default setting saved',

  'importMapping.title.fieldLength': 'Field Length',
  'importMapping.title.fieldName': 'Field Name',
  'importMapping.title.fieldStartPosition': 'Field Start Position',
  'importMapping.title.positionInImportFile': 'Position In Import File',
  'importMapping.title.stripZeroes': 'Strip Zeroes',
  'importMapping.title.trimLeadingBlanks': 'Trim Leading Blanks',
  'importMapping.title.trimLeadingZeros': 'Trim Leading Zeros',
  'importMapping.title.specialFormatting': 'Special Formatting',
  'importMapping.title.fieldPosition': 'Field Position',
  'importMapping.title.replacementValue': 'Replacement Value',
  'importMapping.title.start': 'Start',
  'importMapping.title.length': 'Length',

  'importMapping.validation.emptyFieldSingle':
    'Please specify field start position for <%= fields %>.',
  'importMapping.validation.emptyFieldPlural':
    'Please specify field start positions for <%= fields %>.',
  'importMapping.validation.overlapField': '<%= field1 %> overlaps <%= field2 %>.',
  'importMapping.validation.duplicatedWarning':
    'The Field Position(s) for <%= positions %> has already been used. Please select a different Field Position(s).'
};
